import React, { ComponentProps, useCallback } from 'react';
import { RestartKeycloakHelpText } from '../partials/RestartKeycloakHelpText/RestartKeycloakHelpText';
import Form, { FormUtils, FormContext } from '../../../components/molecules/Form';
import { InteractionStatus } from '../../../types/InteractionStatus';
import { Editor } from '../../../components/molecules/Form/components/Editor';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FormSubmitButton } from '../../../components/molecules/Form/components/FormSubmitButton/FormSubmitButton';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import { useRefreshBlockInDefaultView } from '../../../_lib/BlockFetcher';
import { useDelayed } from '../../../hooks/useDelayed';

type LoginDescriptionEditProps = { form: IForm };

function LoginDescriptionEdit({ form }: LoginDescriptionEditProps) {
  const { t } = useSonTranslation('Editor');
  const { t: tLoginDescription } = useSonTranslation('LoginDescription');
  const { refresh } = useRefreshBlockInDefaultView();
  const delayedRefresh = useDelayed(refresh);
  const keyCloakHelpTextID = 'keycloak-helptext-editor';
  const editorID = 'son-portal-settings';

  const statusMessages = {
    [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t('status.success')),
    [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t('status.sending')),
    [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t('status.fail')),
  };

  /**
   * Handles the submit process and saves a copy of the sent values
   */
  const onSuccess = useCallback(() => {
    delayedRefresh();
  }, [delayedRefresh]);

  return (
    <>
      <RestartKeycloakHelpText id={keyCloakHelpTextID} />
      <Form id="login-description-edit-view-form" model={form} onSuccess={onSuccess}>
        <FormContext.Consumer>
          {({ inputs, onChange, getStatus }) => (
            <>
              <Editor
                value={inputs.son_portal_loginDescription.value}
                name={inputs.son_portal_loginDescription.name}
                id={editorID}
                onChange={(event: any) => {
                  onChange(event.target?.name, event.target?.value);
                  // abortRefetch();
                }}
              />
              <FormSubmitButton
                buttonLabel={tLoginDescription('saveButton')}
                ariaDescribedBy={keyCloakHelpTextID}
                enabled
              />
              <LiveRegion invisible={false} htmlTag="div">
                {getStatus(statusMessages)}
              </LiveRegion>
            </>
          )}
        </FormContext.Consumer>
      </Form>
    </>
  );
}

export const LoginDescriptionEditView = asFetchableView(LoginDescriptionEdit);
export type LoginDescriptionEditView = ComponentProps<typeof LoginDescriptionEditView>;
